/* eslint-disable */
import { useTranslation } from "react-i18next";
import { Button, FormControl, InputAdornment, Paper, TextField } from "@mui/material";
import React, { useState } from "react";
import styles from "./PaymentModal.module.scss";
import CloseIcon from "@mui/icons-material/Close";
import { createPayment } from "../../../actions/payment";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { useEffect } from "react";
import { listAgencies } from "../../../actions/offer";
import { getCurrentTicketAcceptedOffer } from "../../../actions/tickets";
import {
  formatDualCurrency,
  formatMoney,
  getBaseCurrencyBySwitchDate,
  getCurrencySymbol,
  getDisplayCurrencyOrderBySwitchDate,
  getDualAmountsFromBase,
} from "../../../utils/currency";

const PaymentModal = ({ handleClose, createPayment, currentTicket, listAgencies, agencies, getCurrentTicketAcceptedOffer, currentTicketOffer }) => {
  const { t } = useTranslation();
  const [price, setPrice] = useState(null);
  const [description, setDescription] = useState("");
  const now = new Date();
  const baseCurrency = getBaseCurrencyBySwitchDate(now);
  const displayOrder = getDisplayCurrencyOrderBySwitchDate(now);
  const normalizedPriceForDisplay = String(price || "").replace(",", ".");
  const dualForDisplay = getDualAmountsFromBase(
    normalizedPriceForDisplay,
    baseCurrency
  );
  const secondaryCurrency = displayOrder[1];
  const secondaryAmount = dualForDisplay?.[secondaryCurrency];
  const secondaryHelperText =
    secondaryAmount === null || secondaryAmount === undefined
      ? ""
      : `≈ ${formatMoney(secondaryAmount)} ${getCurrencySymbol(
          secondaryCurrency
        )}`;

  useEffect(() => {
    getCurrentTicketAcceptedOffer(currentTicket?._id);
    listAgencies({
      onSuccess: (res) => {},
    });
  }, []);

  useEffect(() => {
    if (!currentTicketOffer) return;
    console.log("[Payment][modal] currentTicketOffer", {
      hasOffer: Boolean(currentTicketOffer?.offer),
      offerId: currentTicketOffer?.offer?._id,
      hasBgn: Boolean(currentTicketOffer?.offer?.bgn),
      premium: currentTicketOffer?.offer?.premium,
      originalPremium: currentTicketOffer?.offer?.originalPremium,
      bgnPremium: currentTicketOffer?.offer?.bgn?.premium,
      bgnOriginalPremium: currentTicketOffer?.offer?.bgn?.originalPremium,
    });
  }, [currentTicketOffer]);

  return (
    <Paper className={styles["assign-topic-modal"]}>
      <div className={styles["assign-topic-heading-container"]}>
        <h3>{t("modals:initiatePaymentTitle")}</h3>
        <CloseIcon onClick={handleClose} />
      </div>
      <FormControl style={{ marginTop: "-3%" }}>
        <p style={{ padding: "10px" }}>{t("modals:amountToPay")}</p>
        <TextField
          value={price}
          onChange={(e) => setPrice(e.target.value)}
          sx={{ padding: "10px" }}
          variant="outlined"
          id="price-input"
          size="small"
          type="number"
          helperText={secondaryHelperText}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <p className={styles["suffix"]}>
                  {getCurrencySymbol(baseCurrency)}
                </p>
              </InputAdornment>
            ),
          }}
        />
      </FormControl>
      <FormControl style={{ marginTop: "-3%" }}>
        <p style={{ padding: "10px" }}>{t("modals:reason")}</p>
        <TextField
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          sx={{ padding: "10px" }}
          variant="outlined"
          id="description-input"
          multiline={true}
          rows={3}
        />
      </FormControl>
      <Paper elevation={10} style={{ padding: "10px" }}>
        <Button
          onClick={() => {
            const normalizedPrice = String(price || "").replace(",", ".");
            const dual = getDualAmountsFromBase(normalizedPrice, baseCurrency);

            if (Number(normalizedPrice) > 0 && description.length > 0) {
              let payload = {
                customerId: currentTicket?.customer?._id,
                amount: Number(normalizedPrice),
                description: description,
                ticket: currentTicket?._id,
              };
              if (currentTicketOffer?.offer)
                payload.discountMetadata = {
                  discountCampaignRef: currentTicket?.promoData?._id,
                  originalAmount: currentTicketOffer?.offer?.originalPremium,
                  discountedAmount: currentTicketOffer?.offer?.premium,
                  policyType: currentTicket?.promoData?.policyType,
                  insuranceAgency: agencies?.filter((agency) => agency?._id === currentTicketOffer?.offer?.insuranceCompanyId)[0].platform,
                };

              console.log("[Payment][modal] submit", {
                now: now?.toISOString?.() || String(now),
                inputRaw: price,
                normalizedPrice,
                assumedBaseCurrency: baseCurrency,
                displayOrder,
                dualDisplay: formatDualCurrency(dual, displayOrder),
                payload,
              });
              createPayment(payload);
              handleClose();
            } else {
              toast.error(t("modals:fieldNotFilled"));
            }
          }}
          disableElevation
          disableRipple
          disableFocusRipple
          disabled={price ? false : true}
          variant="contained"
          sx={{
            width: "100%",
            color: "white",
            backgroundColor: "#01d088",
            cursor: "pointer",
            "&:hover": {
              backgroundColor: "#01d088",
            },
          }}
        >
          {t("confirm")}
        </Button>
      </Paper>
    </Paper>
  );
};

const mapStateToProps = (state) => ({
  user: state.login.user,
  agencies: state.offer.agencies,
  currentTicketOffer: state.tickets.currentTicketOffer,
});

const mapDispatchToProps = (dispatch) => ({
  createPayment: (payload) => dispatch(createPayment(payload)),
  listAgencies: (payload) => dispatch(listAgencies(payload)),
  getCurrentTicketAcceptedOffer: (payload) => dispatch(getCurrentTicketAcceptedOffer(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PaymentModal);
